export default __webpack_public_path__ + "static/media/A_03_01_bg_v04.ca1de6bf.mp4";